import { AddonHtmlElementData } from '@/components/addons/html-element/Data';
import AddonModel from '@/models/grid/AddonModel';
import { AddonModelState } from '@/typings/interfaces/state/Addon';

export interface AddonHTMLState extends AddonModelState {
  html: string;
}

export class AddonHTMLModel extends AddonModel<AddonHtmlElementData, AddonHTMLState> {
  parseAddon(data: AddonHtmlElementData) {
    const state = this.state;
    state.html = data.settings.html ?? '<p>Hello world!</p>';
  }

  authorSignature(): string {
    return 'Nicky Christensen';
  }
}
